import { configureStore } from "@reduxjs/toolkit";
import userReducer, {
  checkAccessTokenApi,
  setToken,
} from "../reducers/userSlice";
import appReducer from "../reducers/appSlice";
import offerReducer, { fetchOffers } from "../reducers/offerSlice";
import appointmentReducer, {
  fetchAppointments,
} from "../reducers/appointmentSlice";

import carBuyReducer, { fetchCarBuys } from "../reducers/carBuySlice";

import { refreshToken } from "../../service";
import axiosJWT from "../../service/axiosJwt";

export const store = configureStore({
  reducer: {
    users: userReducer,
    app: appReducer,

    carBuys: carBuyReducer,
    offer: offerReducer,
    appointments: appointmentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

axiosJWT.interceptors.request.use(
  async (config) => {
    const currentDate = new Date();
    const exp = localStorage.getItem("exp");
    if (Number(exp) * 1000 > currentDate.getDate()) {
      const response = await refreshToken();
      config.headers.Authorization = `Bearer ${response.data.refreshToken}`;
      store.dispatch(setToken(response.data.refreshToken));
      // store.dispatch(setUserInfoRefresh(response.data.userInfo_refresh));
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Promise.all([
  store.dispatch(fetchCarBuys()),
  store.dispatch(fetchOffers()),

  store.dispatch(fetchAppointments()),

  store.dispatch(checkAccessTokenApi()),
])
  .catch(() => {
    // Fehler (z. B. 401 ohne Login) werden in den Slices behandelt
  });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
